export default {
  telefono: "",
  correo: "",
  rut: "",
  nuevo_registro: null,
  coordenadas: null
}